<template>
	<div class="full" style="background-color: white;">
		<el-container class="full">
			<el-aside width="250px" style="border-right: 1px solid #DCDFE6;">
				<emun-tree :field="name" ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-aside>
			<el-container class="full flex"
				style="position: relative;flex-direction: column;box-sizing: border-box;padding: 20px;">
				<el-header class="bread" style="position: relative;height: 30px;">
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="parentbread.length!=0">
						<el-breadcrumb-item v-for="(item,index) in parentbread" :key="index">{{item.name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<div v-else></div>
				</el-header>
				<el-main>
					<el-divider content-position="left">配置</el-divider>
					<el-form ref="form" :model="form" label-width="80px" v-loading="loading"
						style="flex: 1;position: relative;" v-if="currentitem && currentitem.children.length==0"
						element-loading-background="rgba(255, 255, 255, 0.5)">
						<el-form-item label="任务介绍" label-width="80px" style="width: 600px;">
							<el-input type="textarea" :rows="10" placeholder="任务介绍" v-model="form.introduce">
							</el-input>
						</el-form-item>
						<el-form-item label="基础积分" label-width="80px" style="width: 600px;">
							<el-input-number size="mini" v-model="form.score" label="基础积分"></el-input-number>
						</el-form-item>
						<el-form-item label="附加积分" label-width="80px" style="width: 600px;">
							<el-input-number size="mini" v-model="form.additionalscore" label="附加积分"></el-input-number>
						</el-form-item>
						<el-form-item>
							<el-button style="float: right;" type="success" @click="onSubmit" size="mini">保存</el-button>
						</el-form-item>
					</el-form>
				</el-main>
			</el-container>
		</el-container>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	import Sortable from 'sortablejs'
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	export default {
		name: 'emunextend_tasktypeIndex',
		props: {
			name: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading: false,
				currentitem: null,
				emunid: 0,
				emuntTreeKey: Math.random(),
				parentbread: [],
				tableData: [],
				form: {
					score: 0,
					additionalscore: 0,
					introduce:''
				}
			}
		},
		watch: {
			emunid() {
				this.get()
			}
		},
		created() {
			let field = []
			for (let i in this.attr) {
				field.push(i)
			}
			if (field.length != 0) {
				this.$api.emunlist.list({
					field: field.join(',')
				}).then((res) => {
					res.forEach((item) => {
						this.attr[item.field].push(item)
					})
				})
			}
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			rowDrop() {
				this.$nextTick(() => {
					const xTable = this.$refs.cityWarehouseOrder
					this.sortable1 = Sortable.create(xTable.$el.querySelector(
						'.body--wrapper>.vxe-table--body tbody'), {
						handle: '.drag-btn',
						onEnd: ({
							newIndex,
							oldIndex
						}) => {

							const currRow = this.tableData.splice(oldIndex, 1)[0]
							this.tableData.splice(newIndex, 0, currRow)
							console.log(this.tableData)
						}
					})
				})
			},
			importwarehouse() {
				this.tableData = window.systemData.warehouse.map((item) => {
					return {
						warehouseid: item.id,
						warehousecode: item.code,
						warehousewlnid: item.wlnid,
						warehousewlnname: item.wlnname,
						warehousename: item.name,
					}
				})
				this.$nextTick(() => {
					this.rowDrop()
				})
			},
			get() {
				if (!this.emunid) {
					this.$message.error('请选择商品')
					return
				}
				this.loading = true
				this.$api.emunextend_tasktype.get(this.emunid).then((res) => {
					this.loading = false
					if (res) {
						this.form.score = res.score
						this.form.additionalscore = res.additionalscore
						this.form.introduce = res.introduce
					} else {
						this.form.score = 0
						this.form.additionalscore = 0
						this.form.introduce = ''
					}

				})
			},
			onSubmit() {
				if (!this.emunid) {
					this.$message.error('请选类型')
					return
				}
				this.$api.emunextend_tasktype.save({
					emunvalueid: this.emunid,
					score: this.form.score,
					additionalscore: this.form.additionalscore,
					introduce: this.form.introduce
				}).then(() => {
					this.$message.success('操作成功')
				})

			},
			emuntTreeChange(e) {
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
		},
		components: {
			emunTree,

		}
	}
</script>